import React, { useEffect, useState } from "react";
import "./subCatManagement.scss";
import { SearchBar } from "components/form";
import { subCategoryListApi } from "services/subCategory";
import NotFound from "common/NotFound";

import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { FaEdit, FaRegTrashAlt, FaToggleOff, FaToggleOn } from "react-icons/fa";
import findSerialNumber from "utils/findSerialNumber";
import useFullPageLoader from "common/UseFullPageLoader";
import { CustomModal } from "components/modals/ModalBox";
import AddSubCat from "./AddSubCat";
// import { Pagination } from "react-bootstrap";
import useDebounce from "common/UseDebounce";
import Pagination from "react-js-pagination";
import EditSubCat from "./EditSubCat";
import DeleteSubCategory from "./DeleteSubCategory";
import ChangeSubCategoryStatus from "./ChangeSubCategoryStatus";
import { userPlaceholder } from "assets/icons";


const SubCategoryManagement = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  // const [catTab, setTabCat] = useState("CATEGORY");

  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [catFetchedData, setFetchedSubCatData] = useState([]);
    const navigate = useNavigate();
  

  const [searchParams, setSearchParams] = useSearchParams();

  const activePage = +searchParams.get("page") || 1;

  const limit = +searchParams.get("limit") || 10;

  const [total, setTotal] = useState(null);

  const catDataFetchApiCall = async () => {
    try {
      onShow();

      const query = {
        page: activePage,
        limit: limit,
      };

      if (search && debouncedValue) {
        query.search = debouncedValue;
      }

      const {
        data: {
          data: { data, total },
          status,
          code,
        },
      } = await subCategoryListApi(query);

      if (code === 200 || status) {
        setFetchedSubCatData(data);
        console.log("total------------", total);
        setTotal(total);
      }
    } catch (error) {
      console.log("Cat Data fetch error:---> ", error);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    catDataFetchApiCall();
  }, [debouncedValue, activePage, limit]);

  // ----------- show and hide Components state

  const [addCategoryModalState, setAddSubCategoryModalState] = useState(false);
  // ------main cat
  const [showCatManagement, setShowCatManagement] = useState(true);

  const [editSubCategoryModalState, setEditSubCategoryModalState] =
    useState(false);

  const [selectedSubCatIdState, setSelectedSubCatIdState] = useState("");

  // console.log("catFetchedData:---------->", catFetchedData);

  const [selectedCategoryDetail, setSelectedCategoryDetail] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);

  const closeModel = () => {
    setAddSubCategoryModalState(false);
    setShowCatManagement(true);
    setEditSubCategoryModalState(false);
    setSelectedCategoryDetail({});
    setDeleteModal(false);
    setStatusModal(false);

    // catDataFetchApiCall();
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };

  // -------------show image model

  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [imagePreview, setImagePreview] = useState("");

  // show image preview handler
  const showImagePreviewHandler = (profile) => {
    setShowImagePreviewModel(true);
    setImagePreview(profile);
  };

  console.log("catFetchedData:---------->", catFetchedData);

  return (
    <div>
      {showCatManagement && (
        <div>
          <div className="page_title">
            <h3>Sub Category Management</h3>
          </div>

          {/* ----------tabs related data */}
          <div className="card">
            {loader}

            {/* ------search box and add category */}

            <div className="search-add-cat">
              {/* -search wrapper */}
              <div className="search_wrapper">
                <SearchBar
                  placeholder={"Search..."}
                  onKeyDown={(e) => {
                    const allowedKeysRegex = /^[a-zA-Z0-9\- ]$/;
                    const controlKeys = [
                      "Backspace",
                      "ArrowLeft",
                      "ArrowRight",
                      "Delete",
                      "Tab",
                      "Escape",
                    ];

                    // Allow letters, numbers, space, hyphen
                    if (
                      allowedKeysRegex.test(e.key) ||
                      controlKeys.includes(e.key)
                    ) {
                      return;
                    }

                    // Block everything else
                    e.preventDefault();
                  }}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    const urlInstance = new URLSearchParams(searchParams);

                    urlInstance.set("page", 1);
                    setSearchParams(urlInstance);
                  }}
                  value={search}
                />
              </div>

              {/* -----add cat button */}
              <div>
                  <Link to={"/sub-Category-Management/Add-sub-Category"} className="button">Add Sub Category</Link>
                {/* <button
                  className="button"
                  onClick={() => {
                    setAddSubCategoryModalState(true);
                    setShowCatManagement(false);
                  }}
                >
                  Add Sub Category
                </button> */}
              </div>
            </div>

            {/* ------- menu header-------- */}

            <div className="table-container">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap text-center">S.No</th>
                    <th className="nowrap text-center">Icons</th>
                                        <th className="nowrap text-center">Category Name</th>

                    <th className="nowrap text-center">Sub Category Name</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {catFetchedData && catFetchedData.length ? (
                    catFetchedData?.map((mapProp, index) => {
                      // console.log(mapProp?.image);
                      return (
                        <tr key={index}>
                          <td className="nowrap text-center">
                            {findSerialNumber(index, activePage, limit)}
                          </td>

                          <td className="nowrap text-center">
                            <img
                              src={mapProp?.image}
                              alt={mapProp?.name}
                              className="td-img"
                              onClick={() =>
                                showImagePreviewHandler(mapProp?.image)
                              }
                            />
                          </td>
                             <td className="nowrap text-center">
                            {mapProp.category?.name}
                          </td>
                          <td className="nowrap text-center">
                            {mapProp?.name}
                          </td>
                          <td className="nowrap text-center">
                            <div className="button-container">
                              <button
                                type="button"
                                onClick={() => {
                                  setSelectedCategoryDetail(mapProp);
                                  setStatusModal(true);
                                }}
                              >
                                {mapProp?.status === "ACTIVE" ? (
                                  <FaToggleOn size={18} />
                                ) : (
                                  <FaToggleOff size={18} />
                                )}
                              </button>

                              <button
                                type="button"
                                 onClick={(e) => {
                            navigate(
                              `/sub-Category-Management/Edit-sub-Category/${mapProp?._id}`,
                            );
                          }}
                               
                              >
                                <FaEdit />
                              </button>
                              {/* <Link to={"/sub-Category-Management/Edit-sub-Category"}>
                                <FaEdit />

                              </Link> */}
                              {/* ----delete Button */}

                              <button
                                type="button"
                                onClick={() => {
                                  setSelectedCategoryDetail(mapProp);
                                  setDeleteModal(true);
                                }}
                              >
                                <FaRegTrashAlt />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"Category data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {showImagePreviewModel && (
        <CustomModal
          className={"sm image_preview_modal"}
          show={showImagePreviewModel}
          handleClose={() => {
            setImagePreview("");
            setShowImagePreviewModel(false);
          }}
        >
          <div className="image_preview">
            <img
              src={imagePreview || userPlaceholder}
              alt="user-profile-preview"
            />
          </div>
        </CustomModal>
      )}

      {/* ------------------Change token Status*/}
      {statusModal && (
        <ChangeSubCategoryStatus
          selectedCategoryDetail={selectedCategoryDetail}
          onClose={() => closeModel()}
          catDataFetchApiCall={catDataFetchApiCall}
          statusModal={statusModal}
        />
      )}

      {/* -----add sub Cat */}
      {addCategoryModalState && (
        <AddSubCat
          // setAddSubCategoryModalState={setAddSubCategoryModalState}
          setFetchedSubCatData={catDataFetchApiCall}
          closeModel={closeModel}
        />
      )}

      {/* -----edit sub category */}

      {/* -----add sub Cat */}
      {editSubCategoryModalState && (
        <EditSubCat
          // setAddSubCategoryModalState={setAddSubCategoryModalState}
          setFetchedSubCatData={catDataFetchApiCall}
          closeModel={closeModel}
          selectedSubCatIdState={selectedSubCatIdState}
        />
      )}

      {/* Delete BANNER Modal */}
      {deleteModal && (
        <DeleteSubCategory
          deleteModal={deleteModal}
          selectedCategoryDetail={selectedCategoryDetail}
          catFetchedData={setFetchedSubCatData}
          closeModel={closeModel}
        />
      )}

      {/* --------pagination wrapper */}

      {showCatManagement && (
        <div>
          {total > limit && (
            <div className="pagination-wrapper">
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  hideDisabled={true}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SubCategoryManagement;
